<mmu-striped-diamond-bg
  *mmuFeatureEnabled="featureFlags.FFGeneralNewBGFrame; else oldBG"
  class="mmu-move-bg-frame__bg"></mmu-striped-diamond-bg>

<header class="mmu-move-bg-frame__header">
  <mmu-browser-support-banner>
    <!-- This component will hide itself when not required -->
  </mmu-browser-support-banner>
  <mmu-maintenance-banner>
    <!-- This component will hide itself when not required -->
  </mmu-maintenance-banner>
  <a *ngIf="config.showBackLink" class="mmu-move-bg-frame__back-link" (click)="goBack()">
    <mui-icon font="fa" name="chevron-left"></mui-icon>
    <span>{{ 'global.btn.back' | translate }}</span>
  </a>
  <a id="miele-logo" href="/" class="mmu-move-bg-frame__header__logo mui-logo"></a>
</header>
<main class="mmu-move-bg-frame__content container" [@routeAnimations]="componentName">
  <!-- Either use as parent component for routing or inside a view for transcluding content -->
  <router-outlet (activate)="activateChildComponent($event)"></router-outlet>
  <ng-content></ng-content>
</main>

<mmu-footer class="mmu-move-bg-frame__footer"></mmu-footer>

<ng-template #oldBG>
  <mmu-move-parallax-bg class="mmu-move-bg-frame__bg"></mmu-move-parallax-bg>
</ng-template>
